import { PropsWithChildren } from "react";
import "../../scss/formStyles.scss";

interface IProps {}

export function FormWrapper(props: PropsWithChildren<IProps>) {
  return <div className="form-group-wrapper">{props.children}</div>;
}
